import { Tag } from '@vtex/admin-ui'
import { defineMessages, useIntl } from 'react-intl'

import type { ColumnParams, SimplifiedPromotion } from 'typings'

import { getStatusInfo } from '../../status'

export const statusMessages = defineMessages({
  status: { id: 'admin/promotions.filters.status' },
  completed: { id: 'admin/promotions.list.status.completed' },
  scheduled: { id: 'admin/promotions.list.status.scheduled' },
  running: { id: 'admin/promotions.list.status.running' },
  paused: { id: 'admin/promotions.list.status.paused' },
})

export function Status({ item }: ColumnParams<SimplifiedPromotion>) {
  const intl = useIntl()
  const { id, color } = getStatusInfo(item)

  return <Tag label={intl.formatMessage(statusMessages[id])} variant={color} />
}
